export class Column {

    name:string;
    type:string;

    constructor(colName:string,colType:string) {
        this.name = colName;
        this.type = colType;
    }
}
